import React from 'react'
import './LegislatureDiagram.scss'
import LegislaturePlan from './LegislaturePlan'
import { IReduxState } from '../../utils/ReduxStore'
import { connect } from 'react-redux'
import { resultForKey } from '../../controllers/DataController'
import Party from '../../models/Party'
import PartyResultMap from '../../models/PartyResultMap'
import PartyResult from '../../models/PartyResult'

interface IState {
  width: number
  height: number
}

interface IStateProps {
  compareResultKey: string
  baseResultKey: string
}

interface IProps extends IStateProps {}

class LegislatureDiagram extends React.Component<IProps, IState> {
  protected diagramRef: React.RefObject<HTMLDivElement>
  protected legislaturePlan: LegislaturePlan

  public constructor(props: IProps) {
    super(props)
    this.diagramRef = React.createRef()

    this.state = {
      width: 1000,
      height: 500
    }

    this.legislaturePlan = new LegislaturePlan()

    window.addEventListener('resize', (): void => {
      this.setDimensions()
    })
  }

  public componentDidMount(): void {
    this.setDimensions()
  }

  protected setDimensions(): void {
    const currentRef = this.diagramRef.current
    const dimensions = currentRef
      ? {
          width: currentRef.getBoundingClientRect().width,
          height: currentRef.getBoundingClientRect().height
        }
      : { width: 1000, height: 500 }
    this.setState(dimensions)
  }

  public render(): JSX.Element {
    const nationalResult = resultForKey(this.props.compareResultKey)
    const results = nationalResult.partyResultMap

    console.log('results', results)

    const SHOW_GEO = false

    let ridingWinners = nationalResult.ridingResults()

    const ridingWinnersGroupedByParty = ridingWinners
      .slice(0, ridingWinners.length)
      .sort((a, b): number => {
        const aSeatCount = (results.resultForParty(
          a.winner().party
        ) as PartyResult).seatCount
        const bSeatCount = (results.resultForParty(
          b.winner().party
        ) as PartyResult).seatCount
        if (aSeatCount === bSeatCount) {
          return a.winner().party.key === Party.LIB.key ? -1 : 1 // In tie, keep incumbent low
        } else {
          return bSeatCount - aSeatCount
        }
      })

    const seatGap = 1

    let seatWidth =
      Math.floor(this.state.width / LegislaturePlan.NUM_SEATS_PER_ROW) - seatGap
    let seatHeight =
      Math.floor(this.state.height / LegislaturePlan.NUM_ROWS) - seatGap

    if (SHOW_GEO) {
      seatWidth = Math.floor((this.state.width * 4) / 338) / 4
      seatHeight = 40
    }

    if (SHOW_GEO) {
      ridingWinners = ridingWinners.reverse()
      this.legislaturePlan.fillSeats(ridingWinners)
    } else {
      this.legislaturePlan.fillSeats(ridingWinnersGroupedByParty)
    }
    const seats = this.legislaturePlan.getSeatArray()

    const seatDivs = seats.map(
      (seat, index): JSX.Element => {
        let styles = {}

        if (SHOW_GEO) {
          styles = {
            width: seatWidth,
            height: seatHeight,
            left: index * seatWidth,
            top: 0,
            backgroundColor: seat.occupant.rgbColor
          }
        } else {
          styles = {
            width: seatWidth,
            height: seatHeight,
            left: seat.plan.x * (seatWidth + seatGap),
            top: seat.plan.y * (seatHeight + seatGap),
            backgroundColor: seat.occupant.rgbColor
          }
        }
        return (
          <div className="Seat" key={seat.num} style={styles}>
            {seat.occupant.key}
          </div>
        )
      }
    )

    console.log('seats', seats)

    return (
      <div className="row">
        <div className="col">
          <h2>Legislature results</h2>
          <div id="LegislatureDiagram" ref={this.diagramRef}>
            {seatDivs}
          </div>
        </div>
      </div>
    )
  }
}

export const mapStateToProps = (state: IReduxState): IStateProps => ({
  baseResultKey: state.baseResultKey,
  compareResultKey: state.compareResultKey
})

export default connect(mapStateToProps)(LegislatureDiagram)
